import { 
  djtSearchByDivisionStatus, 
  djtSearchByDivisionTeamMemberStatus, 
  djtSearchByDivisionTeamMemberClientStatus, 
  djtSearchByDivisionClientStatus } from '../../../graphql/custom_queries';

import { generateClient } from 'aws-amplify/api';
const client = generateClient();

export const searchDjtsByDivision = async (props) => {
  
  if (!props) return
  try {    

    // searchProps.statusGroup = 'submitted-invoiced'
    // searchProps.statusIds = `${pendingApprovalStatusId},${invoicedQBStatusId},${invoicedOtherStatusId}`
    
    // props now include djtStatusId to search
    // djtStatusId, divisionId, djtClientId, djtDate, 'djtDateStart', 'djtDateEnd', limit
    // 0. ALL, ORDER BY DATE DESC, LIMIT n    djtDivisionId: "87e0ca1a-42c9-4e72-ae80-c9a507bfbd50", limit: 5, sortDirection: DESC
    // 1. CLIENT, ORDER BY DATE DESC, LIMIT n     djtDivisionId: "87e0ca1a-42c9-4e72-ae80-c9a507bfbd50", limit: 5, sortDirection: DESC, filter: {djtClientId: {eq: "87ac8687-c55c-405b-98ba-df3a34426721"}}
    // 2. DATE, ORDER BY DATE DESC, LIMIT n       djtDivisionId: "87e0ca1a-42c9-4e72-ae80-c9a507bfbd50", limit: 5, sortDirection: DESC, djtDate: {eq: "2023-01-24"}
    // 3. DATE RANGE, ORDER BY DATE DESC, LIMIT n     djtDivisionId: "87e0ca1a-42c9-4e72-ae80-c9a507bfbd50", limit: 5, sortDirection: DESC, djtDate: {between: ["2023-01-01","2023-01-27"]})
    // 4. CLIENT, DATE, ORDER BY DATE DESC, LIMIT n     djtDivisionId: "87e0ca1a-42c9-4e72-ae80-c9a507bfbd50", limit: 5, sortDirection: DESC, djtDate: {eq: "2023-01-27"}, filter: {djtClientId: {eq: "aae660ec-67f7-4387-a925-d74b76ac85a4"}}
    // 5, CLIENT, DATE RANGE, ORDER BY DATE DESC, LIMIT n     djtDivisionId: "87e0ca1a-42c9-4e72-ae80-c9a507bfbd50", limit: 5, sortDirection: DESC, djtDate: {between: ["2023-01-01", "2023-01-27"]}, filter: {djtClientId: {eq: "aae660ec-67f7-4387-a925-d74b76ac85a4"}}
    const { djtStatusId, statusGroup, statusIds, divisionId, multiDivisions=[], teamMemberId, djtClientId, djtDate, djtEndDate, limit=999, nextToken, nextTokenArray=[] } = props;
    const isConsecutiveSearch = (statusGroup === 'submitted-invoiced') ? true : false
    const statusIdsArray = (statusIds) ? statusIds?.split(',') : []

    // Build the list of division IDs to query.
    // For team-member-scoped queries (queryFilters 6-11), iterate over all divisions
    // the supervisor belongs to so DJTs from any of their divisions are returned.
    // For division-only queries (0-5), use only the currently selected divisionId.
    const divisionIdsForTeamMemberQuery = (multiDivisions && multiDivisions.length > 0)
      ? multiDivisions
      : [divisionId]

    const queryFilters = [
      { //0
        djtDivisionStatus: `${divisionId}#${djtStatusId}`, 
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
      },
      { //1
        djtDivisionClientStatus: `${divisionId}#${djtClientId}#${djtStatusId}`, 
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
      },
      { //2
        djtDivisionStatus: `${divisionId}#${djtStatusId}`, 
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
        djtDate: {eq: djtDate}
      },
      { //3
        djtDivisionStatus: `${divisionId}#${djtStatusId}`, 
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
        djtDate: {between: [djtDate, djtEndDate]}
      },
      { //4
        djtDivisionClientStatus: `${divisionId}#${djtClientId}#${djtStatusId}`, 
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
        djtDate: {eq: djtDate}, 
      },
      { //5
        djtDivisionClientStatus: `${divisionId}#${djtClientId}#${djtStatusId}`, 
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
        djtDate: {between: [djtDate, djtEndDate]}, 
      },
      { //6 
        djtDivisionTeamMemberClientStatus: `${divisionId}#${teamMemberId}#${djtClientId}#${djtStatusId}`,
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
      },
      { //7
        djtDivisionTeamMemberClientStatus: `${divisionId}#${teamMemberId}#${djtClientId}#${djtStatusId}`,
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
        djtDate: {eq: djtDate}, 
      },
      { //8
        djtDivisionTeamMemberClientStatus: `${divisionId}#${teamMemberId}#${djtClientId}#${djtStatusId}`,
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
        djtDate: {between: [djtDate, djtEndDate]}, 
      },
      { //9
        djtDivisionTeamMemberStatus: `${divisionId}#${teamMemberId}#${djtStatusId}`,
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
        djtDate: {eq: djtDate}
      },
      { //10
        djtDivisionTeamMemberStatus: `${divisionId}#${teamMemberId}#${djtStatusId}`,
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
        djtDate: {between: [djtDate, djtEndDate]}
      },
      { //11
        djtDivisionTeamMemberStatus: `${divisionId}#${teamMemberId}#${djtStatusId}`,
        limit: limit, 
        sortDirection: 'DESC',
        nextToken: nextToken,
      },
    ]
    
    const hasClient = (djtClientId!=='' && djtClientId!==null)
    const hasDjtDate = (djtDate!=='' && djtDate!==null)
    const hasDjtEndDate = (djtEndDate!=='' && djtEndDate!==null)
    const hasTeamMember = (teamMemberId!=='' && teamMemberId!==null)

    let queryFilter = 0
    // by default, search for Division, TeamMember, Status
    if (hasTeamMember) {
      queryFilter = 11
    }
    // client only
    if (hasClient && !hasDjtDate && !hasDjtEndDate) {
      if (hasTeamMember) {
        queryFilter = 6
      } else {
        queryFilter = 1
      }
    }
    // client and startdate only
    if (hasClient && hasDjtDate && !hasDjtEndDate) {
      if (hasTeamMember) {
        queryFilter = 7
      } else {
        queryFilter = 4
      }
    }
    // client and startdate and enddate
    if (hasClient && hasDjtDate && hasDjtEndDate) {
      if (hasTeamMember) {
        queryFilter = 8
      } else {
        queryFilter = 5
      }
    }
    // startdate only
    if (!hasClient && hasDjtDate && !hasDjtEndDate) {
      if (hasTeamMember) {
        queryFilter = 9
      } else {
        queryFilter = 2
      }
    }
    // startdate and enddate only
    if (!hasClient && hasDjtDate && hasDjtEndDate) {
      if (hasTeamMember) {
        queryFilter = 10
      } else {
        queryFilter = 3
      }
    }

    // console.log('queryFilter: ', queryFilter)
    console.log('queryFilter: ', queryFilter)

    // ─── Helper: run djtByDivisionTeamMemberStatus across all divisions ──────
    // Runs the query for every division in divisionIdsForTeamMemberQuery and
    // merges the results into a single items array.
    const queryTeamMemberStatusAllDivisions = async (buildQuery) => {
      const resultsArray = []
      for (const divId of divisionIdsForTeamMemberQuery) {
        const query = buildQuery(divId)
        const response = await client.graphql({
          query: djtSearchByDivisionTeamMemberStatus,
          variables: query
        })
        const items = response?.data?.djtByDivisionTeamMemberStatusComposite?.items || []
        resultsArray.push(...items)
      }
      return resultsArray
    }

    // ─── Helper: run djtByDivisionTeamMemberClientStatus across all divisions ─
    const queryTeamMemberClientStatusAllDivisions = async (buildQuery) => {
      const resultsArray = []
      for (const divId of divisionIdsForTeamMemberQuery) {
        const query = buildQuery(divId)
        const response = await client.graphql({
          query: djtSearchByDivisionTeamMemberClientStatus,
          variables: query
        })
        const items = response?.data?.djtByDivisionTeamMemberClientStatus?.items || []
        resultsArray.push(...items)
      }
      return resultsArray
    }

    // Division TeamMember Status (queryFilters 9, 10, 11)
    if (queryFilter===9 || queryFilter===10 || queryFilter===11) {
      let results = {}
      let resultsArray = []
      console.log('isConsecutiveSearch: ', isConsecutiveSearch)
      console.log('statusIdsArray: ', statusIdsArray)

      if (isConsecutiveSearch) {
        for (const [index, id] of statusIdsArray.entries()) {
          // Find a matching nextToken for this status ID if one exists
          let currentNextToken = null
          for (const obj of nextTokenArray.entries()) {
            if (obj.id === id) { currentNextToken = obj.nextToken; break }
          }
          const items = await queryTeamMemberStatusAllDivisions((divId) => ({
            djtDivisionTeamMemberStatus: `${divId}#${teamMemberId}#${id}`,
            limit: 350,
            sortDirection: 'DESC',
            nextToken: currentNextToken,
            ...(queryFilter===9 && { djtDate: {eq: djtDate} }),
            ...(queryFilter===10 && { djtDate: {between: [djtDate, djtEndDate]} }),
          }))
          console.warn(` 1----- division loop index ${index}, items: `, items)
          resultsArray.push(...items)
        }
        results.nextToken = null
        results.items = resultsArray
        return results
      } else {
        const items = await queryTeamMemberStatusAllDivisions((divId) => ({
          djtDivisionTeamMemberStatus: `${divId}#${teamMemberId}#${djtStatusId}`,
          limit: limit,
          sortDirection: 'DESC',
          nextToken: nextToken,
          ...(queryFilter===9 && { djtDate: {eq: djtDate} }),
          ...(queryFilter===10 && { djtDate: {between: [djtDate, djtEndDate]} }),
        }))
        results.nextToken = null  // multi-division queries don't support pagination via nextToken
        results.items = items
        return results
      }
    }

    // Division TeamMember Client Status (queryFilters 6, 7, 8)
    if (queryFilter===6 || queryFilter===7 || queryFilter===8) {
      let results = {}
      let resultsArray = []
      console.log('isConsecutiveSearch: ', isConsecutiveSearch)
      console.log('statusIdsArray: ', statusIdsArray)

      if (isConsecutiveSearch) {
        for (const [index, id] of statusIdsArray.entries()) {
          const items = await queryTeamMemberClientStatusAllDivisions((divId) => ({
            djtDivisionTeamMemberClientStatus: `${divId}#${teamMemberId}#${djtClientId}#${id}`,
            limit: 350,
            sortDirection: 'DESC',
            nextToken: null,
            ...(queryFilter===7 && { djtDate: {eq: djtDate} }),
            ...(queryFilter===8 && { djtDate: {between: [djtDate, djtEndDate]} }),
          }))
          console.log(` 2----- division loop index ${index}, items: `, items)
          resultsArray.push(...items)
        }
        results.nextToken = null
        results.items = resultsArray
        return results
      } else {
        const items = await queryTeamMemberClientStatusAllDivisions((divId) => ({
          djtDivisionTeamMemberClientStatus: `${divId}#${teamMemberId}#${djtClientId}#${djtStatusId}`,
          limit: limit,
          sortDirection: 'DESC',
          nextToken: nextToken,
          ...(queryFilter===7 && { djtDate: {eq: djtDate} }),
          ...(queryFilter===8 && { djtDate: {between: [djtDate, djtEndDate]} }),
        }))
        results.nextToken = null
        results.items = items
        return results
      }
    }

    // Division Client Status (queryFilters 1, 4, 5)
    // These are division-scoped (no teamMember), so no multi-division loop needed
    if (queryFilter===1 || queryFilter===4 || queryFilter===5) {
      let results = {}
      let currentResults = null
      let resultsArray = []
      if (isConsecutiveSearch) {
        for (const [index, id] of statusIdsArray.entries()) {
          const newQuery = {
            djtDivisionClientStatus: `${divisionId}#${djtClientId}#${id}`, 
            limit: limit, 
            sortDirection: 'DESC',
            nextToken: null,
          }
          console.log(' ----- newQuery: ', index, newQuery)
          const response = await client.graphql({
            query: djtSearchByDivisionClientStatus,
            variables: newQuery
          })
          currentResults = response.data.djtByDivisionClientStatus.items
          console.log('currentResults: ', index, currentResults)
          resultsArray.push(...currentResults)
        }
        results.nextToken = null
        results.items = resultsArray
        return results
      } else {
        const response = await client.graphql({
          query: djtSearchByDivisionClientStatus,
          variables: queryFilters[queryFilter]
        })
        const results = response.data.djtByDivisionClientStatus
        return results
      }
    }

    // Division Status (queryFilters 0, 2, 3)
    // Division-scoped only — no multi-division loop needed
    if (queryFilter===0 || queryFilter===2 || queryFilter===3) {
      let results = {}
      let currentResults = null
      let resultsArray = []
      if (isConsecutiveSearch) {
        for (const [index, id] of statusIdsArray.entries()) {
          if (!teamMemberId) {
            const newQuery = {
              djtDivisionStatus: `${divisionId}#${id}`,
              limit: 350, 
              sortDirection: 'DESC',
              nextToken: null,
            }
            console.warn(` ----- newQuery: `, index, newQuery)
            // console.warn(' $----- newQuery: ', newQuery)
            const response = await client.graphql({
              query: djtSearchByDivisionStatus,
              variables: newQuery
            })
            currentResults = response?.data?.djtByDivisionStatusComposite?.items
            resultsArray.push(...currentResults)
          } else {
            // teamMemberId is present but queryFilter landed in 0/2/3 — 
            // loop over all divisions just like the teamMember queries above
            const items = await queryTeamMemberStatusAllDivisions((divId) => ({
              djtDivisionTeamMemberStatus: `${divId}#${teamMemberId}#${id}`,
              limit: limit,
              sortDirection: 'DESC',
              nextToken: null,
            }))
            resultsArray.push(...items)
          }
        }
        results.nextToken = null
        results.items = resultsArray
        return results
      } else {
        const response = await client.graphql({
          query: djtSearchByDivisionStatus,
          variables: queryFilters[queryFilter]
        })
        const results = response.data.djtByDivisionStatusComposite
        return results
      }
    }
    
  } catch(err) {
    return('error searchDjtsByDivision: ', [err]);
  }


}